// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__kYKYi","error":"Notification_error__x-BeS","success":"Notification_success__bDmki"};